import React from 'react';

import HeroBg from '../i/bg_section_4.jpg';

const NotFound = () => {
	return (
		<section className="section">
			<div className="section_bg loaded_mod" style={{ backgroundImage: `url(${HeroBg})` }} />
			<div className="not_found">
				<div className="not_found_in">
					<h1 className="not_found_title">404 </h1>
					<div className="not_found_subtitle">page not found</div>
				</div>
			</div>
		</section>

	);
}
export default NotFound;